export default __webpack_public_path__ + "static/media/small.013fb23a.jpg";